export default __webpack_public_path__ + "static/media/tutorial-step-3-sweepstakes.b2bb17d6.png";